import { NGXLogger } from 'ngx-logger';
import { Component, HostListener, inject } from '@angular/core';
import { AppConstants } from 'src/app/commons/app-constants';
import { UtilService } from 'src/app/services/util.service';
import { SHARED_MODULES } from '../../shared-imports';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [SHARED_MODULES]
})
export class FooterComponent {
  private readonly logger = inject(NGXLogger);

  isMobile: boolean;

  constructor(private utilService: UtilService) {
    this.isMobile = utilService.isMobile();
  //  console.log(`ISMOBILE ${ this.isMobile }`);
  }

  lumberlinq_url = AppConstants.LUMBER_LINQ_WEBSITE;

  openSocialUrl(socialName: string) {
    let url = '';

    switch (socialName.toLowerCase()) {
      case 'facebook':
        url = 'https://www.facebook.com/lumberlinq/';
        break;
      case 'twitter':
        url = 'https://x.com/lumberlinqtms';
        break;
      case 'linkedin':
        url = 'https://www.linkedin.com/company/lumberlinq-tms';
        break;
      case 'instagram':
        url = 'https://www.instagram.com/lumberlinq/';
        break;
      case 'youtube':
        url = 'https://www.youtube.com/@lumberlinq';
        break;
      default:
        this.logger.debug('Unknown social platform');
        return;
    }

    window.open(url, '_blank');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.handleResize();
  }

  handleResize(): void {
    // console.log('Window has been resized!');
    // console.log(`ISMOBILE ${ this.isMobile }`);
  }
}
